// Reference:
// * https://github.com/shadcn-ui/ui/blob/3740373f99e39943514a45f5808ecb5f17faf700/apps/v4/registry/new-york-v4/ui/input.tsx

import { CircleAlert } from "lucide-react";
import type { ComponentProps } from "react";

import { cn } from "@/utils/tailwind";

function Input({
  className,
  type,
  error,
  ...props
}: ComponentProps<"input"> & { error?: string }) {
  const hasError = !!error;
  const errorId = `${props.id || "input"}-error`;

  return (
    <div>
      <div className="relative">
        <input
          aria-describedby={hasError ? errorId : undefined}
          aria-invalid={hasError}
          data-slot="input"
          type={type}
          className={cn(
            "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-1",
            "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
            hasError
              ? "border-destructive focus-visible:ring-destructive/50 pr-10"
              : "",
            className,
          )}
          {...props}
        />

        {hasError && (
          <CircleAlert className="text-destructive pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2" />
        )}
      </div>

      {hasError && (
        <span className="text-destructive mt-2 text-sm" id={errorId}>
          {error}
        </span>
      )}
    </div>
  );
}

export { Input };
